import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SelectionActionBarRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
  padding: theme.spacing(0, 2),
  width: "100%",
  height: 68,
  position: "sticky",
  bottom: 0,
  zIndex: 2,
  boxSizing: "border-box",
  alignSelf: "stretch",
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[3],
}));
